import { CLASS_NAMES, EVENTS, SELECTORS, MISC } from '@bs/constants';
import { closest, MessageBus } from '@bs/utils';

/**
 * A class for the Header module
 */
export default class Header extends MessageBus {
  /**
   * Constructor function of the HeaderFunc class. Must receive one arguments, a DOM
   * node representing a delivery ticket.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {object} element DOM node that is passed into the constructor
     */
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers and
   * then create the event listeners
   * @returns {object} HeaderFunc A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();

    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} HeaderFunc A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    this.search_button = this.element.querySelector(
      `.${CLASS_NAMES.SEARCH}${MISC.BEM_ELEMENT}${SELECTORS.BUTTON}`
    );
    this.search_input = this.element.querySelector(
      `.${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.SEARCH}${MISC.BEM_MODIFIER}${SELECTORS.INPUT}`
    );

    this.hamburger = this.element.querySelector(
      `.${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.HAMBUGER}`
    );
    this.hamburger_menu = this.element.querySelector(
      `.${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.HAMBUGER}${MISC.BEM_MODIFIER}${CLASS_NAMES.MENU}`
    );

    this.MenuToggles = this.element.querySelectorAll(
      `.${CLASS_NAMES.ICON}${MISC.BEM_ELEMENT}${SELECTORS.DOWN_ARROW}`
    );

    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} Search A reference to the current instance of the class
   * @chainable
   */
  enable() {
    if (this.search_button !== null) {
      this.search_button.addEventListener(EVENTS.CLICK, this.toggleSearchinput);
    }
    if (this.hamburger !== null) {
      this.hamburger.addEventListener(EVENTS.CLICK, this.toggleHamburger);
    }
    this.MenuToggles.forEach((MenuToggle) => {
      MenuToggle.addEventListener(EVENTS.CLICK, this.toggleMenuChild);
    });
    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    this.toggleSearchinput = this.toggleSearchHandler.bind(this);
    this.toggleHamburger = this.toggleHamburgerHandler.bind(this);
    this.toggleMenuChild = this.toggleMenuChildHandler.bind(this);

    return this;
  }

  /**
   * This events trigger for toggling search input field on site header.
   *
   */
  toggleSearchHandler() {
    this.search_input.classList.toggle(
      `${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.SEARCH}${MISC.BEM_MODIFIER}${SELECTORS.INPUT}${MISC.BEM_MODIFIER}${MISC.BEM_MODIFIER}${CLASS_NAMES.ACTIVE}`
    );
  }

  /**
   * This events trigger for toggling hamburger menu.
   * @returns {void}
   */
  toggleHamburgerHandler() {
    this.hamburger.classList.toggle(
      `${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.HAMBUGER}${MISC.BEM_MODIFIER}${MISC.BEM_MODIFIER}${CLASS_NAMES.ACTIVE}`
    );
    this.hamburger_menu.classList.toggle(
      `${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.HAMBUGER}${MISC.BEM_MODIFIER}${CLASS_NAMES.MENU}${MISC.BEM_MODIFIER}${MISC.BEM_MODIFIER}${CLASS_NAMES.ACTIVE}`
    );

    this.element.classList.toggle(
      `${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.MENU}${MISC.BEM_MODIFIER}${CLASS_NAMES.ACTIVE}`
    );
  }

  /**
   * This is events trigger for toggle menu child items & changing parent icons appropriately for smaller screen.
   * @param {Event} event - the event object
   * @returns {object} - The instance of the object for method chaining
   */
  toggleMenuChildHandler(event) {
    event.preventDefault();

    if (
      event.target.classList.contains(
        `${CLASS_NAMES.ICON}${MISC.BEM_ELEMENT}${SELECTORS.DOWN_ARROW}`
      )
    ) {
      event.target.classList.add(
        `${CLASS_NAMES.ICON}${MISC.BEM_ELEMENT}${SELECTORS.UP_ARROW}`
      );
      event.target.classList.remove(
        `${CLASS_NAMES.ICON}${MISC.BEM_ELEMENT}${SELECTORS.DOWN_ARROW}`
      );
    } else {
      event.target.classList.add(
        `${CLASS_NAMES.ICON}${MISC.BEM_ELEMENT}${SELECTORS.DOWN_ARROW}`
      );
      event.target.classList.remove(
        `${CLASS_NAMES.ICON}${MISC.BEM_ELEMENT}${SELECTORS.UP_ARROW}`
      );
    }

    closest(
      event.target,
      `.${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.MENU}${MISC.BEM_MODIFIER}${CLASS_NAMES.LINK}`
    ).nextSibling.nextSibling.classList.toggle(
      `${CLASS_NAMES.HEADER}${MISC.BEM_ELEMENT}${CLASS_NAMES.NAV_CHILD}${MISC.BEM_MODIFIER}${CLASS_NAMES.ACTIVE}`
    );

    return this;
  }
}
